<template>
    <div>

        <config-main-title v-if="!crm">
            Apoiados
        </config-main-title>

        <div class="form-row mb-0">
            <div class="col col-12" :class="crm ? '' : 'col-md-6'">
                <az-input icon="fas fa-search" v-model="search" @input="buscarItems ()">
                    <template v-slot:buttonposb>
                        <importacao 
                            :service="is_origens ? 'apoiado_origens' : 'apoiados'"
                            :parms="{ id_apoiado: item ? item.id_apoiado : '' }" 
                            @refresh="load()" />
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column" v-if="!crm">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'; load();">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'; load();">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column" v-if="!crm">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir {{ is_origens ? 'Origem' : 'Apoiado' }}
                </button>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <div v-if="item && lista_origens !== null" class="alert alert-secondary d-flex justify-content-between">
            <strong>{{ item.search }}</strong>
            <div>
                Locais
                <a href="#" @click.prevent="lista_origens = null" class="card-link ml-3">
                    <i class="fa-solid fa-chevron-left"></i>
                </a>
            </div>
        </div>

        <template v-else>

            <table class="table table-sm border-0 table-responsive mb-1">
                <tr>
                    <td class="text-nowrap">
                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in options_classes" :key="icx">
                            <span class="badge badge-success mr-1" >
                                {{ classe }}
                            </span>
                        </a>
                    </td>
                </tr>
            </table>

        </template>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="is_origens ? 'Nenhum lugar de origem identificado.' : 'Nenhuma apoiado identificado.'" 
                :icon="is_origens ? 'fa-solid fa-location-dot' : 'fa-solid fa-house-signal'" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id"
                    :class="( dado.contato && dado.contato.contato_status && dado.contato.contato_status.st_color ) ? 'list-group-item-' + dado.contato.contato_status.st_color : ''">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span class="badge badge-secondary ml-2">#{{ dado.id_apoiado }}</span>

                        <div v-if="dado.js_classes && dado.js_classes.length">
                            <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in dado.js_classes" :key="icx">
                                <span class="badge badge-success mr-1">
                                    {{ classe }}
                                </span>
                            </a>
                        </div>
                        <div v-if="dado.contato && dado.contato.contato_status" class="small">
                            {{ dado.contato.contato_status.search }}
                        </div>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else-if="!is_origens">
                            <span class="badge badge-dark ml-1 mr-2" v-if="dado.filtros && dado.filtros.length" title="Filtros">
                                <i class="fa fa-filter mr-1" aria-hidden="true"></i>
                                {{ dado.filtros.length }}
                            </span>

                            <template v-if="lista_enquetes && lista_enquetes.length">
                                <a href="#" @click.prevent="preencher_enquente(dado)" 
                                    class="btn btn-sm ml-1" 
                                    :class="dado.enquetes_aplicadas_count > 0 ? 'btn-dark' : 'btn-outline-dark'"
                                    title="Avaliação de Prestador">
                                    <i class="fa-solid fa-clipboard-check"></i>
                                    <span v-if="dado.enquetes_aplicadas_count" class="badge badge-light ml-1">
                                        {{ dado.enquetes_aplicadas_count }}
                                    </span>
                                </a>
                            </template>

                            <button type="button" title="Integração" class="btn btn-outline-success btn-sm ml-1" v-if="dado.st_tipo_acesso == 'T'" @click="integrar (dado)">
                                <i class="fa-solid fa-tower-cell fa-fw"></i>
                            </button>

                            <button type="button" title="Enviar Resultados" class="btn btn-outline-success btn-sm ml-1" v-if="dado.st_tipo_acesso == 'T'" @click="enviar_resultados_tasy (dado)">
                                <i class="fa-solid fa-share-from-square"></i>
                            </button>

                            <button type="button" title="Locais" class="btn btn-outline-primary btn-sm ml-1" @click="editar_locais (dado)">
                                <i class="fa-solid fa-location-dot fa-fw"></i>
                            </button>

                            <button type="button" title="Contatos" class="btn btn-outline-primary btn-sm ml-1" @click="editar_contatos (dado)">
                                <i class="fa-solid fa-comments fa-fw"></i>
                                <span class="badge badge-primary ml-1" v-if="dado.contatos_count">
                                    {{ dado.contatos_count }}
                                </span>
                            </button>

                            <button type="button" title="Arquivos" class="btn btn-outline-primary btn-sm ml-1" @click="abrir_anexos (dado)">
                                <i class="fa-solid fa-paperclip fa-fw" v-if="dado.arquivos && dado.arquivos.length"></i>
                                <i class="fa-solid fa-plus fa-fw" v-else></i>
                            </button>
                        </div>
                    </span>
                </li>
            </div>

            <template v-if="dados.last_page > 1">
                <nav class="navbar fixed-bottom navbar-light bg-light pb-3">
                    <div class="d-flex">
                        <paginate
                            class="mb-0"
                            :page-count="dados.last_page"
                            :container-class="'pagination'"
                            :page-class="'page-item'"
                            :page-link-class="'page-link'"
                            :prev-class="'page-link'"
                            :next-class="'page-link'"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :click-handler="load">
                        </paginate>
                    </div>
                </nav>
            </template>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item && !item.integra">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_apoiado ? '' : 'Novo' }}
                            Apoiado
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_apoiado">{{ item && item.id_apoiado ? '#' + item.id_apoiado : '' }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    sizing="sm"
                                    label="Nome"
                                    :validate="validate"
                                    required
                                    v-model="item.st_nome" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    label="Sigla"
                                    :validate="validate"
                                    v-model="item.st_sigla" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    label="Id Externo"
                                    :validate="validate"
                                    v-model="item.st_id_externo" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Tipo de Acesso / Lançamento"
                                    type="select"
                                    sizing="sm" 
                                    placeholder="Selecione..."
                                    :optionsList="[
                                        { id: 'A', search: 'API' }, 
                                        { id: 'K', search: 'Integração Klingo' }, 
                                        { id: 'V', search: 'Integração MV' }, 
                                        { id: 'N', search: 'Integração Nephrosys' }, 
                                        { id: 'T', search: 'Integração Philips Tasy' }, 
                                        { id: 'S', search: 'Integração Smart' }, 
                                        { id: 'P', search: 'Integração SPDATA' }, 
                                        { id: 'M', search: 'Manual / Portal' }, 
                                        { id: 'U', search: 'Unidade Avançada' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_tipo_acesso" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Token API"
                                    placeholder="Não definido..."
                                    :edicao="false"
                                    v-model="item.st_token_api">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-sm btn-outline-primary" @click="gerar_token_api()" :disabled="$store.state.loading">
                                                Gerar
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <!-- URL de Integração Smart -->
                        <div class="alert alert-info d-flex justify-content-between" v-if="item.st_tipo_acesso == 'S' && item.st_token_api">
                            <div>
                                URL Smart B2B: <strong>{{ link_smart_b2b }}</strong>
                            </div>
                            <div>
                                <a href="#" @click.prevent="copiar_texto(link_smart_b2b, 'Link de Integração copiado.')">
                                    <i class="fas fa-copy"></i>
                                </a>
                            </div>
                        </div>

                        <div v-if="item.st_tipo_acesso == 'S' && item.st_token_api" class="mb-3">
                            <az-input
                                sizing="sm"
                                label="URL retorno/envio (XML) de resultados Smart"
                                placeholder="Não definido..."
                                v-model="item.st_url_envio">
                            </az-input>
                        </div>

                        <!-- URL de Integração MV -->
                        <div class="alert alert-info" v-if="item.st_tipo_acesso == 'V' && item.st_token_api">
                            <div class="d-flex justify-content-between">
                                <div>
                                    URL Requisição: <strong>{{ link_mv_req_b2b }}</strong>
                                </div>
                                <div>
                                    <a href="#" @click.prevent="copiar_texto(link_mv_req_b2b, 'Link de Integração copiado.')">
                                        <i class="fas fa-copy"></i>
                                    </a>
                                </div>
                            </div>
                            <hr>
                            <div class="small text-muted">
                                <i class="fa-solid fa-circle-info mr-2"></i>
                                Necessário realizar o de-para dos procedimentos.
                            </div>
                        </div>

                        <!-- URL de Integração Nephrosys -->
                        <div class="alert alert-info" v-if="item.st_tipo_acesso == 'N' && item.st_token_api">
                            <div class="d-flex justify-content-between">
                                <div>
                                    URL Requisição: <strong>{{ link_nephrosys_req_b2b }}</strong>
                                </div>
                                <div>
                                    <a href="#" @click.prevent="copiar_texto(link_nephrosys_req_b2b, 'Link de Integração copiado.')">
                                        <i class="fas fa-copy"></i>
                                    </a>
                                </div>
                            </div>
                            <hr>
                            <div class="d-flex justify-content-between">
                                <div>
                                    URL Resultado: <strong>{{ link_nephrosys_res_b2b }}</strong>
                                </div>
                                <div>
                                    <a href="#" @click.prevent="copiar_texto(link_nephrosys_res_b2b, 'Link de Integração copiado.')">
                                        <i class="fas fa-copy"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="mb-3" v-if="item && item.id_apoiado && $store.state.user && item.st_tipo_acesso == 'S'">
                            <importar-xml-smart 
                                :id_apoiado="item.id_apoiado"
                                v-if="item && item.id_apoiado && $store.state.user && $store.state.user.id_usuario == 1 && item.st_tipo_acesso == 'S'"></importar-xml-smart>
                        </div>

                        <div class="mb-3" v-if="item && item.id_apoiado && $store.state.user && item.st_tipo_acesso == 'N'">
                            <importar-txt-nephrosys 
                                :id_apoiado="item.id_apoiado"></importar-txt-nephrosys>
                        </div>
                        
                        <div class="form-row" v-if="item.st_tipo_acesso == 'K' && item.st_token_api">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Prefixo do Código de Amostra"
                                    required
                                    :validate="validate"
                                    v-model="item.st_klingo_prefixo_amostra" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Cobrança (Fonte Pagadora)"
                                    type="select" 
                                    optionsMode="aql"
                                    optionsData="id_operadora"
                                    optionsDisplay="st_operadora"
                                    service="operadoras.index"
                                    :optionsParm="{ 
                                        fatura: true,
                                        lista: true
                                    }"
                                    optionsName="operadoras-para-apoiado"
                                    placeholder="Fonte Pagadora..."
                                    :edicao="!item.id_plano"
                                    v-model="item.id_operadora">
                                </az-input>
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Plano / Produto"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    optionsData="id_plano"
                                    optionsDisplay="st_plano"
                                    service="planos.index"
                                    :optionsParm="{ id_operadora: item.id_operadora }"
                                    :edicao="item.id_operadora ? true : false"
                                    optionsName="planos"
                                    placeholder="Plano / Produto..."
                                    v-model="item.id_plano" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Recepção Atendimento"
                                    sizing="sm"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    optionsData2="id_recepcao"
                                    optionsDisplay="search"
                                    service="recepcaos.index"
                                    :optionsParm="{ filtros: true }"
                                    optionsName="recepcaos.apoiados"
                                    placeholder="Recepção..."
                                    v-model="item.recepcao" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Código Convênio Externo"
                                    :validate="validate"
                                    v-model="item.st_chave_convenio" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Código Local Externo"
                                    :validate="validate"
                                    v-model="item.st_chave_leg" />
                            </div>
                        </div>

                        <div class="form-row mt-3">
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Permitir cadastrar pedido pelo portal do apoiado"
                                    sizing="sm"
                                    type="checkbox-group"
                                    v-model="item.fl_cad_portal" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Permitir editar pedido via integração mesmo com exame em aberto"
                                    sizing="sm"
                                    type="checkbox-group"
                                    v-model="item.fl_atualiza_status_amostra" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Bloquear visualização no laudo no portal do paciente"
                                    sizing="sm"
                                    type="checkbox-group"
                                    v-model="item.fl_block_acesso_paciente" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Permitir impressão em bloco no portal do apoiado"
                                    sizing="sm"
                                    type="checkbox-group"
                                    v-model="item.fl_imp_bloco" />
                            </div>
                        </div>

                        <!-- Vinculo pela Recepção -->
                        <div class="form-row" v-if="item.recepcao">
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Vincular atendimentos dessa recepção ao apoiado automaticamente"
                                    sizing="sm"
                                    type="checkbox-group"
                                    v-model="item.fl_vinc_recep" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Gerar orçamento ao invés de atendimento nas requisições por API"
                                    sizing="sm"
                                    type="checkbox-group"
                                    v-model="item.fl_orcamento" />
                            </div>
                        </div>

                        <!-- Amostra Pendente -->
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Lançar amostra pendente, quando integrado"
                                    sizing="sm"
                                    type="checkbox-group"
                                    v-model="item.fl_amostra_pendente" />
                            </div>

                            <div class="col col-12 col-md-6" v-if="item.st_tipo_acesso == 'S'">
                                <az-input  
                                    label="Código de Barras do Solicitante"
                                    sizing="sm"
                                    type="checkbox-group"
                                    v-model="item.fl_etq_origem" />
                            </div>
                        </div>

                        <div v-if="item.fl_etq_origem && item.st_tipo_acesso == 'S'" class="alert alert-info p-2 small">
                            O código de barras do solicitante será utilizado para identificar a amostra.
                        </div>

                        <div class="form-row" v-if="item.st_tipo_acesso != 'S'">
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Planilha de Resultados no Portal"
                                    sizing="sm"
                                    type="checkbox-group"
                                    v-model="item.fl_portal_download" />
                            </div>
                        </div>

                        <div v-if="item.id_apoiado && item.usuarios">
                            <az-sub-title class="mt-2" title="Usuário do Portal do Apoiado" />

                            <ul class="list-group mb-3" v-if="item.usuarios && item.usuarios.length">
                                <li class="list-group-item d-flex justify-content-between" v-for="(usuario_ap, iux) in item.usuarios" :key="iux">
                                    <div>
                                        {{ usuario_ap.st_login }}

                                        <span v-if="usuario_ap.pessoa && usuario_ap.pessoa.st_nome" class="small text-muted mx-3">
                                            {{ usuario_ap.pessoa.st_nome }}
                                        </span>

                                        <span v-if="usuario_ap.js_classes && usuario_ap.js_classes.length">
                                            <span class="badge badge-success ml-1" v-for="(classe, icx) in usuario_ap.js_classes" :key="icx">
                                                {{ classe }}
                                            </span>
                                        </span>
                                    </div>
                                    <div>
                                        <a href="#" @click.prevent="editar_usuario(usuario_ap)" title="Redefinir Senha.">
                                            <i class="fas fa-edit"></i>
                                        </a>

                                        <a href="#" @click.prevent="redefinir_senha_modal(usuario_ap)" title="Redefinir Senha." class="ml-3">
                                            <i class="fa-solid fa-key"></i>
                                        </a>

                                        <a href="#" @click.prevent="toggle_user_bloq(usuario_ap)" class="ml-3">
                                            <i class="fa-regular fa-circle text-primary fa-fw" title="Acesso liberado" v-if="!usuario_ap.fl_bloqueado"></i>
                                            <i class="fa-solid fa-ban text-danger fa-fw" title="Acesso bloqueado" v-else></i>
                                        </a>
                                    </div>
                                </li>
                            </ul>

                            <div class="form-row">
                                <div class="col col-12">
                                    <div class="input-group input-group-sm mb-3">
                                        <input type="text" class="form-control" placeholder="Novo Login (Opcional)..." v-model="novo_login" :disabled="$store.state.loading">

                                        <select class="form-control" v-if="lista_item_tags && lista_item_tags.length" v-model="nova_origem" :disabled="$store.state.loading">
                                            <option value="">Origem...</option>
                                            <option v-for="(origem, iox) in lista_item_tags" :key="iox" :value="origem.id">
                                                {{ origem.search }}
                                            </option>
                                        </select>
                                        
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-sm btn-outline-primary" @click="criar_login_portal()" :disabled="$store.state.loading">Criar Login</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    type="textarea"
                                    label="Observações"
                                    sizing="sm"
                                    rows="3"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div class="form-row mt-3">
                            <div class="col col-12">
                                <small class="text-muted">Classificação</small>
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <!-- Contatos -->
                        <az-sub-title class="mt-3" title="Contatos" />
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    sizing="sm"
                                    type="fone"
                                    label="Telefone"
                                    v-model="item.st_telefone" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input   
                                    sizing="sm"
                                    type="email"
                                    label="e-mail"
                                    v-model="item.st_email" />
                            </div>
                        </div>

                        <template v-if="item.origem_tags && item.origem_tags.length">
                            <template v-if="item.js_contatos">
                                <div class="form-row" v-for="(contato, icx) in item.js_contatos" :key="icx">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            :label="icx ? '' : 'Origem'"
                                            required
                                            :validate="validate"
                                            :optionsList="item.origem_tags.map(item => { return { id: item, search: item } })"
                                            optionsData="id"
                                            optionsDisplay="search"
                                            v-model="contato.origem">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button type="button" class="btn btn-outline-danger" @click="remover_contato(icx)">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            type="fone"
                                            :label="icx ? '' : 'Telefone'"
                                            :validate="validate"
                                            v-model="contato.telefone" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            type="email"
                                            :label="icx ? '' : 'e-mail'"
                                            :validate="validate"
                                            v-model="contato.email" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            type="Obs"
                                            :label="icx ? '' : 'Observação'"
                                            :validate="validate"
                                            v-model="contato.obs" />
                                    </div>
                                </div>
                            </template>

                            <button type="button" class="btn btn-outline-primary btn-sm" @click="incluir_contato_apoiado()">
                                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                            </button>
                        </template>

                        <!-- Portal -->
                        <div v-if="item.portal_consultas && is_dna" class="mt-3">
                            <az-sub-title title="Informações/Resultados" />
                            <div v-for="(consulta, icx) in item.portal_consultas" :key="icx">
                                <div class="form-row" v-if="consulta.fl_ativo">
                                    <div class="col col-12 col-md-9">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Título..."
                                            required 
                                            :validate="validate"
                                            v-model="consulta.st_titulo">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button type="button" class="btn btn-outline-danger" @click="consulta.fl_ativo = false">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-1">
                                        <az-input
                                            sizing="sm"
                                            type="number"
                                            placeholder="DCE..."
                                            required 
                                            :validate="validate"
                                            v-model="consulta.st_info" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            type="number"
                                            placeholder="Período Máximo (dias)..."
                                            required 
                                            :validate="validate"
                                            v-model="consulta.in_max_periodo_dias" />
                                    </div>
                                </div>
                            </div>
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir_consulta()">
                                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                            </button>
                        </div>

                        <div v-if="item.campos_customizados && item.campos_customizados.js_campos.length" class="row mt-3">
                            <div class="col col-12">
                                <az-sub-title :title="item.campos_customizados.st_titulo" />
                                <formulario 
                                    :gutters="true" 
                                    v-model="item.campos_customizados.js_campos" 
                                    :saved="true" 
                                    mode="fixed"
                                    :validate="validate"
                                    :config="true" />
                            </div>
                        </div>

                        <div v-if="item.js_configs" class="mt-3">
                            <az-sub-title title="Configurações" />
                            <div class="form-row">
                                <div v-for="(valor, chave, icx) in item.js_configs" :key="icx" class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        :label="chave"
                                        v-model="item.js_configs[chave]" />
                                </div>
                            </div>
                        </div>

                        <div class="mt-3">
                            <az-sub-title title="De-Paras">
                                <a href="#" @click.prevent="incluir_depara()" class="card-link">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                    Incluir De-Para
                                </a>
                            </az-sub-title>
                            <div v-for="(depara, idx) in item.deparas" :key="idx" >
                                <div class="form-row" v-show="!depara.excluido">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="opcoes_depara"
                                            optionsData="id"
                                            :validate="validate"
                                            required
                                            :edicao="!depara.model_id"
                                            v-model="depara.model_type">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" @click="depara.excluido = true">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>                                
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            :edicao="false"
                                            v-if="( depara.model_type && depara.model_id && depara.model )"
                                            v-model="depara.model.search">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="depara.model_id">
                                                    <span class="input-group-text">
                                                        #{{ depara.model_id}}
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>

                                        <az-input
                                            v-else
                                            sizing="sm"
                                            type="autocomplete"
                                            optionsMode="aql"
                                            :optionsSync="!infoFiltroModel(depara.model_type).nosync"
                                            :service="infoFiltroModel(depara.model_type).service" 
                                            :optionsName="'filtro-' + depara.model_type + infoFiltroModel(depara.model_type).name"
                                            :optionsParm="{ ativos: true, agenda: true, ...infoFiltroModel(depara.model_type).parms }"
                                            :edicao="( depara.model_type && !depara.model_id ) ? true : false"
                                            placeholder="Selecione..."
                                            v-model="depara.model">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="depara.model_id">
                                                    <span class="input-group-text">
                                                        #{{ depara.model_id}}
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            icon="fa-solid fa-code"
                                            placeholder="De-Para..."
                                            v-model="depara.st_id_externo" />
                                    </div>
                                </div>
                            </div> 

                            <a href="#" @click.prevent="incluir_depara()" class="btn btn-outline-primary btn-sm">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </a>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <br><br><br><br><br>

                    </div>

                    <div class="modal-footer">
                        <az-audit-log-button model="apoiado" :id="item.id_apoiado" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_apoiado ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Intregração -->
        <div class="modal fade" id="integracaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item && item.integra">
                    <div class="modal-header">
                        <h5 class="modal-title">Integração</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="lista_recepcoes_depara && lista_recepcoes_depara.length" class="mb-3">
                            <az-input
                                required
                                :validate="validate"
                                label="Estabelecimento (Recepção)"
                                type="select"
                                optionsMode="json"
                                :optionsList="lista_recepcoes_depara"
                                optionsData="id_recepcao"
                                v-model="item.id_recepcao" />
                        </div>

                        <az-submit color="primary mb-3" @click="realizar_integracao()">Obter Exames Pendentes</az-submit>

                        <div class="alert alert-info" v-if="!item.lista">
                            Realizar integração para obter os pedidos pendentes.
                        </div>

                        <az-empty-state icon="fa-solid fa-file-powerpoint" msg="Nenhum pedido identificado" v-else-if="item.lista && !item.lista.length" />

                        <template v-else-if="item.lista && item.lista.length">

                            <div class="alert alert-liight border">
                                <div class="row">
                                    <div class="col col-12 col-md-6">
                                        <div>
                                            <i class="fa-solid fa-square mr-2 text-success"></i>Exame/Material OK
                                        </div>
                                        <div>
                                            <i class="fa-solid fa-square mr-2 text-warning"></i>De-Para informado do material inválido
                                        </div>
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <div>
                                            <i class="fa-solid fa-square mr-2 text-danger"></i>De-Para informado do exame inválido
                                        </div>
                                        <div>
                                            <i class="fa-solid fa-square mr-2 text-dark"></i>De-Para do exame não informado
                                        </div>
                                    </div>
                                </div>
                            </div>       

                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        type="datetime-local"
                                        label="Data do Atendimento"
                                        required
                                        :validate="validate"
                                        v-model="item.data_atend" />                     
                                </div>
                                <div class="col col-12 col-md-8">
                                    <az-input
                                        label="Pesquisa"
                                        v-model="pesquisa_integra">
                                        <template v-slot:buttonposb>
                                            <print-export printid="lista-atend-apoiado" :left="true" :dados="dados_exportacao_integracao" />
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <table class="table table-hover table-sm cabecalho-fixo-modal" id="lista-atend-apoiado">
                                <thead>
                                    <tr>
                                        <th>
                                            <a href="#" @click.prevent="select_all(lista_integracao)" class="card-link">
                                                <i class="fa fa-square" aria-hidden="true"></i>
                                            </a>
                                        </th>
                                        <table-th title="Pedido" v-model="ordem_integra" sortby="numero"></table-th>
                                        <table-th title="Data" v-model="ordem_integra" sortby="data"></table-th>
                                        <table-th title="Paciente" v-model="ordem_integra" sortby="paciente.nome"></table-th>
                                        <table-th title="Obs" v-model="ordem_integra" sortby="obs_coleta"></table-th>
                                        <th>Exames</th>
                                        <table-th title="Atend." v-model="ordem_integra" sortby="marcacao.id_atendimento"></table-th>
                                    </tr>
                                    <tr class="table-info">
                                        <td colspan="7" class="text-center">
                                            <span>Pedidos: {{ integra_selecionados.length }} / {{ item.lista.length }}</span>
                                            <span class="ml-5" v-if="pesquisa_integra">Filtrados: {{ integra_lista_selecionados.length }} / {{ lista_integracao.length }}</span>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(pedido, ipx) in lista_integracao" :key="ipx">
                                        <td>
                                            <input type="checkbox" v-model="pedido.selec" />
                                        </td>
                                        <td>
                                            {{ pedido.numero }}
                                        </td>
                                        <td>
                                            {{ $util.getFormatDate(pedido.data) }}
                                        </td>
                                        <td>
                                            {{ pedido.paciente.nome }}
                                            <div class="small text-muted">{{ pedido.paciente.cpf }}, {{ pedido.paciente.sexo }}, {{ $util.getFormatDate(pedido.paciente.dtnasc) }}</div>
                                        </td>
                                        <td>
                                            <a href="#" @click.prevent="filtrar_integra(pedido.obs_coleta)" class="card-link">
                                                {{ pedido.obs_coleta }}
                                            </a>
                                        </td>
                                        <td>
                                            <a href="#" @click.prevent="pedido.cor = null">
                                                <span class="badge mr-1" :class="pedido.cor ? 'badge-' + pedido.cor : 'badge-secondary'">
                                                    <!-- {{ pedido.exames.length == 1 ? pedido.exames[0].codigo : pedido.exames.length }} -->
                                                    {{ pedido.exames.length }}
                                                </span>
                                            </a>

                                            <template v-if="!pedido.cor">
                                                <a href="#" @click.prevent="abrir_detalhes(exame)" v-for="(exame, iex) in pedido.exames" :key="iex">
                                                    <span class="badge mr-1" :class="exame.cor ? 'badge-' + exame.cor : 'badge-light'">
                                                        {{ exame.codigo == '?' ? exame.descricao : exame.codigo }}
                                                    </span>
                                                </a>
                                            </template>
                                        </td>
                                        <td>
                                            <span v-if="pedido.marcacao && pedido.marcacao.id_atendimento">#{{ pedido.marcacao.id_atendimento }}</span>
                                            <span v-else-if="pedido.marcacao && !pedido.marcacao.id_atendimento">M{{ pedido.marcacao.id_marcacao }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="item && item.lista && item.lista.length" @click="capturar_pedidos()">Capturar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <br><br><br><br><br>

        <registrar-contatos 
            :lista_status="lista_status" 
            :extra_parms="{ solicitante: true }"
            ref="regcontatos" 
            @refresh="load()">
            <template v-slot:info>
                <div class="alert alert-info" v-if="edicao">
                    {{ edicao.st_nome }}
                </div>
            </template>
        </registrar-contatos>

        <template v-if="acao_anexar && edicao && edicao.arquivos">
            <az-file-upload
                :tem_validade="true"
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="edicao.arquivos"
                :parms="{ model_type: 'apoiado', model_id: edicao.id_apoiado }" />
        </template>

        <!-- Modal Detalhe Exame -->
        <div class="modal fade" id="detalheExameModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Dado de Origem</h5>
                        <button type="button" class="close" @click="fechar_modal('detalheExameModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-secondary" v-if="detalhe_exame">
                            {{ detalhe_exame.codigo }} / {{ detalhe_exame.descricao }}
                        </div>

                        <div class="alert alert-info" v-if="detalhe_exame && detalhe_exame.raw">
                            <vue-json-pretty :data="detalhe_exame.raw" :showLength="true" />
                        </div>

                        <div class="alert alert-danger" v-else>
                            Nenhum dado de origem identificado.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('detalheExameModal')">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <az-dispatch ref="dispatch" @refresh="retorno_integracao" @chunkFinal="terminar_captura()" />

        <!-- Cadastro de Origem -->
        <div class="modal fade" id="apoiadoOrigemModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao_origem">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Origem
                            <span class="badge badge-secondary ml-2">{{ edicao_origem.id_apoiado_origem ? '#' + edicao_origem.id_apoiado_origem : 'Nova' }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    sizing="sm"
                                    label="Nome"
                                    :validate="validate"
                                    required
                                    v-model="edicao_origem.st_nome" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    label="Sigla"
                                    :validate="validate"
                                    v-model="edicao_origem.st_sigla" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    label="Id Externo"
                                    :validate="validate"
                                    v-model="edicao_origem.st_id_externo" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Plano / Produto"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    optionsData="id_plano"
                                    optionsDisplay="st_plano"
                                    service="planos.index"
                                    :optionsParm="{ id_operadora: item.id_operadora }"
                                    :edicao="item.id_operadora ? true : false"
                                    optionsName="planos"
                                    placeholder="Padrão..."
                                    v-model="edicao_origem.id_plano" />
                            </div>
                        
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Recepção Atendimento"
                                    sizing="sm"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    optionsData2="id_recepcao"
                                    optionsDisplay="search"
                                    service="recepcaos.index"
                                    :optionsParm="{ filtros: true }"
                                    optionsName="recepcaos.apoiados"
                                    placeholder="Padrão..."
                                    v-model="edicao_origem.recepcao" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="numeric"
                                    label="Código do Solicitante"
                                    :validate="validate"
                                    v-model="edicao_origem.st_chave_solicitante" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="textarea"
                                    label="Observações"
                                    rows="3"
                                    v-model="edicao_origem.st_observacao" />
                            </div>
                        </div>

                        <div class="form-row mt-3">
                            <div class="col col-12">
                                <small class="text-muted">Classificação</small>
                                <multiselect
                                    v-model="edicao_origem.js_classes"
                                    :options="options_classes_origem"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTagOrigem"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <br><br><br><br><br>
                        
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="apoiadoOrigem" :id="edicao_origem.id_apoiado_origem" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_origem()">{{ !edicao_origem.id_apoiado_origem ? 'Incluir' : 'Atualizar' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Redefinir Senha -->
        <div class="modal fade" id="redefinirSenhaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="edicao_senha">
                    <div class="modal-header">
                        <h5 class="modal-title">Redefinir Senha</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="item && item.origem_tags">
                            <az-input
                                placeholder="Todos..."
                                type="select" 
                                :optionsList="item.origem_tags.map(item => { return { id: item, search: item } })"
                                optionsData="id"
                                optionsDisplay="search"
                                v-model="edicao_senha.classe"/>
                        </template>

                        <az-input
                            type="checkbox-group"
                            label="Gerar Senha Aleatória"
                            :validate="validate"
                            v-model="edicao_senha.aleatoria" />

                        <az-input
                            v-if="!edicao_senha.aleatoria"
                            label="Senha"
                            required
                            :validate="validate"
                            v-model="edicao_senha.st_senha" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="redefinir_senha(edicao_senha)">Redefinir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Enviar Resultados Tasy -->
        <div class="modal fade" id="enviarResultadoTasy" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Enviar Resultado Tasy</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_tasy">
                        <div class="alert alert-info">
                            {{ edicao_tasy.search }}
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="button-group"
                                    :optionsList="[
                                        { 'id': 'A', 'search': 'Atendimento' },
                                        { 'id': 'D', 'search': 'Data' },
                                    ]"
                                    optionsData="id"
                                    v-model="tipo_res_tasy" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    v-if="tipo_res_tasy == 'A'"
                                    type="number"
                                    placeholder="Número do Atendimento"
                                    :validate="validate"
                                    required
                                    v-model="num_atend_envio" />

                                <az-input
                                    v-else-if="tipo_res_tasy == 'D'"
                                    type="date"
                                    :validate="validate"
                                    required
                                    v-model="data_envio">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="data_envio">
                                            <button class="btn btn-outline-primary" type="button" @click="obter_atend_tasy_pronto()">
                                                <i class="fa-solid fa-arrows-rotate"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <template v-if="tipo_res_tasy == 'D'">
                            <template v-if="lista_pronto_tasy && lista_pronto_tasy.lista && lista_pronto_tasy.lista.length">
                                <span class="badge badge-secondary mb-3">
                                    {{ lista_pronto_tasy.lista.filter(item => item.selec).length }} /  {{ lista_pronto_tasy.lista.length }} 
                                </span>

                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Atend</th>
                                            <th>Paciente</th>
                                            <th>Origem</th>
                                            <th>E1</th>
                                            <th>E2</th>
                                            <th>E3</th>
                                            <th>E4</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(atend, iat) in lista_pronto_tasy.lista">
                                            <tr :key="iat" v-if="true">
                                                <td>
                                                    <input type="checkbox" v-model="atend.selec" />
                                                </td>
                                                <td>
                                                    #{{ atend.id_atendimento }}
                                                    <span class="badge badge-secondary ml-2">{{ atend.atendimento_procedimentos_count }}</span>
                                                </td>
                                                <td>
                                                    {{ atend.paciente.st_nome }}
                                                </td>
                                                <td>
                                                    {{ atend.marcacao.recepcao.st_nome }}
                                                </td>
                                                <td>
                                                    <a href="#" @click.prevent="atend.show_logs = !atend.show_logs" v-if="atend.retorno && atend.retorno.logs && atend.retorno.logs[0]">
                                                        <span :class="'badge badge-' + cor_status_tasy(atend.retorno.logs[0])">
                                                            {{ atend.retorno.logs[0].status }}
                                                        </span>
                                                    </a>
                                                </td>
                                                <td>
                                                    <a href="#" @click.prevent="atend.show_logs = !atend.show_logs" v-if="atend.retorno && atend.retorno.logs && atend.retorno.logs[1]">
                                                        <span :class="'badge badge-' + cor_status_tasy(atend.retorno.logs[1])">
                                                            {{ atend.retorno.logs[1].status }}
                                                        </span>
                                                    </a>
                                                </td>
                                                <td>
                                                    <a href="#" @click.prevent="atend.show_logs = !atend.show_logs" v-if="atend.retorno && atend.retorno.logs && atend.retorno.logs[2]">
                                                        <span :class="'badge badge-' + cor_status_tasy(atend.retorno.logs[2])">
                                                            {{ atend.retorno.logs[2].status }}
                                                        </span>
                                                    </a>
                                                </td>
                                                <td>
                                                    <a href="#" @click.prevent="atend.show_logs = !atend.show_logs" v-if="atend.retorno && atend.retorno.logs && atend.retorno.logs[3]">
                                                        <span :class="'badge badge-' + cor_status_tasy(atend.retorno.logs[3])">
                                                            {{ atend.retorno.logs[3].status }}
                                                        </span>
                                                    </a>
                                                </td>
                                            </tr>
                                            <template v-if="atend.show_logs && atend.retorno && atend.retorno.logs && atend.retorno.logs.length">
                                                <tr :key="'xml'+ iat" v-if="true">
                                                    <td></td>
                                                    <td colspan="7">
                                                        <table class="table table-secondary">
                                                            <thead>
                                                                <tr>
                                                                    <th>Evento</th>
                                                                    <th>Envio</th>
                                                                    <th>Resposta</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(log, ilx) in atend.retorno.logs" :key="iat + '.' + ilx">
                                                                    <td>
                                                                        <span class="small">{{ log.metodo }}</span>
                                                                        <div>
                                                                            <span class="badge" :class="'badge-' + cor_status_tasy(log)">
                                                                                {{ log.status }}
                                                                            </span>
                                                                        </div> 
                                                                    </td>
                                                                    <td class="small">
                                                                        <span style="white-space: pre-wrap;">{{ log.xml }}</span>
                                                                    </td>
                                                                    <td class="small">
                                                                        <span style="white-space: pre-wrap;">
                                                                            {{ log.resposta }}
                                                                        </span>
                                                                    </td>   
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>                                               
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </template>
                        </template>

                        <template v-else>
                            <template v-if="edicao_tasy.retorno && edicao_tasy.retorno.logs">
                                <table class="table mt-3">
                                    <thead>
                                        <tr>
                                            <th>Evento</th>
                                            <th>Envio</th>
                                            <th>Resposta</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(log, ilx) in edicao_tasy.retorno.logs" :key="ilx">
                                            <td>
                                                <span class="small">{{ log.metodo }}</span>
                                                <div>
                                                    <span class="badge" :class="'badge-' + cor_status_tasy(log)">
                                                        {{ log.status }}
                                                    </span>
                                                </div> 
                                            </td>
                                            <td class="small">
                                                <span style="white-space: pre-wrap;">{{ log.xml }}</span>
                                            </td>
                                            <td class="small">
                                                <span style="white-space: pre-wrap;">
                                                    {{ log.resposta }}
                                                </span>
                                            </td>   
                                        </tr>
                                    </tbody>
                                </table>
                            </template>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="enviar_resultados_atend_tasy()" v-if="tipo_res_tasy == 'A'" :disabled="( edicao_tasy && edicao_tasy.retorno ) ? true : false">Enviar</az-submit>
                        <az-submit @click="enviar_resultados_atend_lote(true)" v-if="tipo_res_tasy == 'D'">Enviar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <apoiado-usuario ref="apoiadoUsuario" @refresh="refresh_user" />

        <enquete ref="enquete" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Importacao from '../shared/Importacao.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';
import Multiselect from 'vue-multiselect';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import VueJsonPretty from 'vue-json-pretty';
import AzDispatch from '../../util/AzDispatch.vue';
import 'vue-json-pretty/lib/styles.css';

import TableTh from '../../shared/table/TableTh.vue';

import PrintExport from '../../shared/PrintExport.vue';
import ImportarXmlSmart from '../../shared/ImportarXmlSmart.vue'; 
import ImportarTxtNephrosys from '../../shared/b2b/ImportarTxtNephrosys.vue';

import ApoiadoUsuario from './ApoiadoUsuario.vue';
import Enquete from '../../shared/Enquete.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            pesquisar_debounce: null, 
            options_classes: [],
            options_classes_origem: [], 
            edicao: null, 
            lista_status: [], 
            acao_anexar: false,
            novo_login: "", 
            nova_origem: "", 
            detalhe_exame: null, 
            chave: null, 
            lista_origens: null, 
            edicao_origem: null, 
            ordem_integra: "", 
            pesquisa_integra: "", 
            edicao_senha: null, 
            edicao_tasy: null, 
            num_atend_envio: null, 
            tipo_res_tasy: "A", 
            lista_pronto_tasy: null, 
            data_envio: "", 
            lista_enquetes: [], 
        }
    },

    props: ['cadastro', 'crm'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle,
        AzAuditLogButton,
        Importacao,
        Formulario, 
        Multiselect, 
        RegistrarContatos, 
        AzFileUpload, 
        FiltroModel, 
        AzDispatch, 
        TableTh,
        PrintExport, 
        VueJsonPretty, 
        ImportarXmlSmart,
        ImportarTxtNephrosys,
        ApoiadoUsuario, 
        Enquete, 
    },

    computed: { 
        lista_item_tags: function () { 
            if ( !this.item || !this.item.origem_tags ) { 
                return [];
            }

            return this.item.origem_tags.map(item => { return { id: item, search: item } });
        },

        is_origens: function () { 
            return ( this.item && this.lista_origens ) ? true : false;
        },

        is_dna: function () { 
            return window.redir == 'dnagenetica'
                || window.redir == 'dnateste'
                || window.redir == 'teste';
        },
        /*
        recepcao: function () { 
            return this.$route.name == 'r-medico-solicitante';
        },
        */

        lista_filtros: function () { 

            if ( !this.item || !this.item.filtros ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            if ( this.is_origens ) { 
                return this.lista_origens.filter(item => this.viewMode == 'T' || item.fl_ativo);
            }
            return this.dados ? this.dados.data.filter(item => this.viewMode == 'T' || item.fl_ativo) : [];
        },

        lista_origens_exibicao: function () { 
            if ( !this.lista_origens ) { 
                return [];
            }

            return this.lista_origens;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\recepcao', search:'Recepção', service:'recepcaos.index', parms: { filtros: true }},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
            ];

            return opcoes;
        },
        
        opcoes_depara: function () { 
            let opcoes = [                        
                {id:'App\\azure\\amostraMaterial', search:'Material da Amostra', service:'amostra_materiais.index', parms: { filtros: true }},
                {id:'App\\azure\\medico', search:'Médico', service:'medicos.index', parms: { filtros: true }},
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service:'procedimentos.index', parms: { filtros: true }},
                {id:'App\\azure\\recepcao', search:'Recepção', service:'recepcaos.index', parms: { filtros: true }},
            ];

            return opcoes;
        },

        integra_lista_selecionados: function () { 
            if ( !this.lista_integracao.length ) { 
                return [];
            }

            return this.lista_integracao.filter(item => item.selec);
        },

        integra_selecionados: function () { 
            if ( !this.item || !this.item.lista || !this.item.lista.length ) { 
                return [];
            }

            return this.item.lista.filter(item => item.selec);
        },

        lista_recepcoes_depara: function () { 
            if ( !this.item ) { 
                return [];
            }

            return _.orderBy(
                this.item.deparas.filter(item => item.model_type == 'App\\azure\\recepcao')
                    .map(item => item.model),
                'search'
            );
        },

        link_smart_b2b: function () { 
            if ( !this.item || !this.item.st_token_api ) { 
                return '?';
            }

            return 'https://api-externa.klingo.app/api/b2b/' 
                + window.redir 
                + '/' 
                + this.item.st_token_api.slice(window.redir.length + 1) 
                + '/smartb2b/api';
        },

        link_mv_req_b2b: function () { 
            if ( !this.item || !this.item.st_token_api ) { 
                return '?';
            }

            return 'https://api-externa.klingo.app/api/integracaomv/pedido/' 
                + window.redir 
                + '/' 
                + this.item.st_token_api.slice(window.redir.length + 1);
        },

        link_nephrosys_req_b2b: function () { 
            if ( !this.item || !this.item.st_token_api ) { 
                return '?';
            }

            return 'https://api-externa.klingo.app/api/nephrosys/' 
                + window.redir 
                + '/' 
                + this.item.st_token_api.slice(window.redir.length + 1) 
                + '/requisicao';
        },

        link_nephrosys_res_b2b: function () { 
            if ( !this.item || !this.item.st_token_api ) { 
                return '?';
            }

            return 'https://api-externa.klingo.app/api/nephrosys/' 
                + window.redir 
                + '/' 
                + this.item.st_token_api.slice(window.redir.length + 1) 
                + '/resultado';
        },

        lista_integracao: function () { 
            if ( !this.item || !this.item.lista )
                return [];

            let reg = this.$util.getregex(this.pesquisa_integra);
            let lista = this.item.lista.filter(item => !this.pesquisa_integra || reg.test(JSON.stringify(item)));

            if ( this.ordem_integra ) { 
                return _.orderBy(lista, this.ordem_integra.name, this.ordem_integra.direction);
            } else { 
                return lista;
            }
        }, 

        dados_exportacao_integracao: function () { 
            if ( !this.lista_integracao || !this.lista_integracao.length ) { 
                return [];
            }

            return this.lista_integracao.map(item => { 
                return { 
                    'Número': item.numero,
                    'Data': item.data,
                    'Paciente': item.paciente ? item.paciente.nome : '',
                    'CPF': item.paciente ? item.paciente.cpf : '',
                    'Sexo': item.paciente ? item.paciente.sexo : '',
                    'DataNascimento': item.paciente ? item.paciente.dtnasc : '',
                    'ObsColeta': item.obs_coleta,
                    'QtdExames': item.exames ? item.exames.length : 0,
                    'Exames': item.exames ? item.exames.map(exame => exame.codigo).join(', ') : '',
                    'Atendimento': ( ( item.marcacao && item.marcacao.id_atendimento ) ? '#' + item.marcacao.id_atendimento : ( ( item.marcacao && !item.marcacao.id_atendimento ) ? 'M' + item.marcacao.id_marcacao : '') ),
                }
            });
        },

    },

    methods: { 
        preencher_enquente(item) { 
            this.$refs.enquete.abrir(item, 'App\\azure\\apoiado', 'id_apoiado'); 
        },

        refresh_user (usuario) { 
            let index = this.item.usuarios.findIndex(u => u.id_usuario == usuario.id_usuario);

            if ( index >= 0 ) { 
                this.$set(this.item.usuarios, index, usuario);
            }
        },

        editar_usuario (usuario) { 
            this.$refs.apoiadoUsuario.abrir(usuario.id_usuario);
        },

        obter_atend_tasy_pronto () { 
            this.lista_pronto_tasy = null;

            this.$util.load(this, { 
                service: 'apoiados',
                func: 'get_atend_tasy_data',
                redir_api: true, 
                parms: { 
                    id_apoiado: this.edicao_tasy.id_apoiado, 
                    data: this.data_envio,
                },
                loadTo: res => { 
                    this.lista_pronto_tasy = res; 
                }
            });
        },

        toggle_user_bloq (usuario) { 
            
            if ( !confirm('Confirma alterar a condição de acesso (bloqueado/liberado)?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'apoiados',
                func: 'toggle_usuario_acesso', 
                dados: { 
                    id_apoiado: usuario.model_id, 
                    id_usuario: usuario.id_usuario
                },
                toast: true, 
                callback: res => { 
                    if ( res.usuario ) { 
                        usuario.fl_bloqueado = res.usuario.fl_bloqueado;
                    }
                }
            });

        },

        cor_status_tasy(log) { 
            if ( !log || !log.status ) 
                return 'secondary';

            if ( log.status == 'sucesso' ) 
                return 'success';
            else if ( log.status == 'falha' ) 
                return 'danger';
            else if ( log.status == 'preparado' ) 
                return 'warning';
            else 
                return 'secondary';

        },

        enviar_resultados_atend_lote (start = false) { 
            let proximo = this.lista_pronto_tasy.lista.find(item => item.selec);

            if ( !proximo && start ) { 
                this.$toast.add({ 
                    summary: 'Integração Tasy', 
                    detail: 'Nenhum atendimento selecionado para envio.', 
                    severity: "warning",
                    life: 5000
                });
                return;
            }

            proximo.selec = false;

            this.enviar_resultados_atend_tasy (proximo);

        },

        enviar_resultados_atend_tasy (proximo = null) { 
            this.$util.atualizar(this, { 
                service: 'apoiados',
                func: 'enviar_resultados_tasy',
                redir_api: true, 
                dados: { 
                    id_apoiado: this.edicao_tasy.id_apoiado, 
                    id_atendimento: proximo ? proximo.id_atendimento : this.num_atend_envio,
                },
                toast: true, 
                callback: res => { 
                    if ( proximo ) { 
                        proximo.retorno = res; 
                        this.enviar_resultados_atend_lote(); 
                    } else { 
                        this.edicao_tasy.retorno = res;
                    }
                }
            });
        },

        enviar_resultados_tasy (apoiado) { 
            let edicao = _.cloneDeep(apoiado);
            edicao.retorno = null; 

            this.edicao_tasy = edicao;
            $('#enviarResultadoTasy').modal('show');
        },

        remover_contato(index) { 
            this.item.js_contatos.splice(index, 1);
        },

        incluir_contato_apoiado() { 
            if ( this.item.js_contatos === null ) { 
                this.item.js_contatos = [];
                this.$forceUpdate();
            }

            this.item.js_contatos.push({
                origem: "", 
                telefone: "", 
                email: "", 
                obs: ""
            });
        },

        redefinir_senha_modal (usuario) { 
            this.edicao_senha = { 
                usuario: usuario,
                id_usuario: usuario.id_usuario,
                classe: _.get(usuario, 'js_classes.0'), 
                aleatoria: true,
                st_senha: "",
            };

            $('#redefinirSenhaModal').modal('show');
        },

        filtrar_integra (texto) { 
            if ( this.pesquisa_integra == '"' + texto + '"' ) { 
                this.pesquisa_integra = "";
            } else { 
                this.pesquisa_integra = '"' + texto + '"';
            }    
        },

        editar_locais (dado) { 
            this.item = _.cloneDeep (dado);

            this.lista_origens = [];

            this.load();
        },

        retorno_integracao (dados) { 
            console.log('retorno_integracao', dados);

            if ( dados ) { 

                if ( dados.data.status_code >= 400 ) { 

                    this.$toast.add({ 
                        summary: 'Erro na Integração', 
                        detail: dados.data.msg, 
                        severity: "error",
                        life: 100000
                    });

                } else if ( dados.data.chave ) { 

                    this.$util.loadItem(this, { 
                        service: 'apoiados',
                        func: 'retorno_tasy',
                        parms: { 
                            chave: this.chave 
                        },
                    })
                    .then(res => { 
                        console.log('res', res);
                        this.item.lista = res.json.lista;
                    });

                }

            }

        },

        incluir_consulta() { 
            this.item.portal_consultas.push({
                st_titulo: "", 
                fl_ativo: true, 
                st_tipo: 'midsmart', 
                fl_parm_periodo: true, 
                in_max_periodo_dias: 31, 
                st_info: "", 
            });
        },

        copiar_texto (texto, titulo = null) { 
            this.$util.copiar_clipboard(this, texto, titulo);
        },

        abrir_detalhes (exame) { 
            this.detalhe_exame = exame;
            $('#detalheExameModal').modal('show');
        },

        fechar_modal (modal) { 
            $('#' + modal).modal('hide');
        },

        incluir_depara () { 
            this.item.deparas.push({
                model_type: "",
                model_id: "",
                st_id_externo: "", 
                excluido: false, 
            });
        },

        infoFiltroModel(model) { 
            if ( !this.opcoes_depara || !model ) 
                return {};

            let opcao = this.opcoes_depara.find(item => item.id == model);

            return opcao;
        },

        select_all (lista) { 
            let selec = lista.find(item => item.selec);

            lista.forEach(element => {
                element.selec = selec ? false : true;
            });
        },

        realizar_integracao () { 
            this.chave = this.$util.uuidv4();

            /*
            this.item.lista = [
                { 
                    selec: false, 
                    numero: 123,
                    paciente: { 
                        nome: 'Fulano', 
                        cpf: '1234', 
                        sexo: 'M',
                        dtnasc: '2000-01-01',
                    },
                    obs_coleta: "2;4;6",
                    data: '2025-01-01',    
                    exames: [], 
                },
                { 
                    selec: false, 
                    numero: 98,
                    paciente: { 
                        nome: 'Beltrano', 
                        cpf: '1234', 
                        sexo: 'M',
                        dtnasc: '2004-01-01',
                    },
                    obs_coleta: "3;5;6",
                    data: '2025-01-12',    
                    exames: [], 
                },
                { 
                    selec: false, 
                    numero: 450,
                    paciente: { 
                        nome: 'Cicrano', 
                        cpf: '1234', 
                        sexo: 'M',
                        dtnasc: '2004-01-01',
                    },
                    obs_coleta: "2;4;6",
                    data: '2024-01-12',    
                    exames: [], 
                }
            ];
            */

            this.$refs.dispatch.executar_com_progresso(
                'integrar', 
                'apoiados', 
                { 
                    id_apoiado: this.item.id_apoiado, 
                    id_recepcao: this.item.id_recepcao, 
                    chave: this.chave, 
                },
                this.chave, 
                '', 
                true
            );

            /*
            this.$util.atualizar(this, { 
                service: 'apoiados',
                func: 'integrar', 
                redir_api: true, 
                dados: { 
                    id_apoiado: this.item.id_apoiado, 
                    id_recepcao: this.item.id_recepcao, 
                    chave: chave, 
                },
                toast: true, 
                callback: res => { 
                    this.item.lista = res.lista;
                },
            });
            */
        },

        terminar_captura() { 
            this.$toast.add({ 
                summary: 'Capturar Pedidos', 
                detail: 'Processo concluído', 
                severity: "success",
                life: 10000
            });

            $('#integracaoModal').modal('hide');
        },

        capturar_pedidos () { 
            this.$refs.dispatch.executar_chunck(
                'apoiados', 
                'capturar', 
                this.item.lista.filter(item => item.selec), 
                'lista', 
                { 
                    id_apoiado: this.item.id_apoiado, 
                    data_atend: this.item.data_atend,
                },
                2, 
            );

            /*
            this.$util.atualizar(this, { 
                service: 'apoiados',
                func: 'capturar',
                redir_api: true,  
                dados: { 
                    id_apoiado: this.item.id_apoiado, 
                    lista: this.item.lista.filter(item => item.selec), 
                },
                toast: true, 
                modal: 'integracaoModal',
            });
            */
        },

        integrar (item) { 
            this.validate = false; 

            let novo = _.cloneDeep(item);
            novo.lista = null;
            novo.integra = true; 

            this.item = novo;
            $('#integracaoModal').modal('show');
        },

        generateRandomString(size) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            const charactersLength = characters.length;
            
            for (let i = 0; i < size; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            
            return result;
        },

        gerar_token_api () { 
            this.item.st_token_api = window.redir + ':' + this.generateRandomString(32);    
        },

        carregar_arquivos(abrir = false) {
            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.edicao.id_apoiado,
                    type: 'apoiado',
                }
            })
            .then(res => {
                this.edicao.arquivos = res;

                if ( abrir ) {
                    this.$nextTick(() => {
                        this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });
        },

        abrir_anexos (item) {
            this.acao_anexar = true;

            this.edicao = _.cloneDeep(item);

            if ( this.edicao.arquivos && this.edicao.arquivos.length
                && !this.edicao.arquivos.find(arq => arq.arquivo) ) {

                this.carregar_arquivos(true);
                return;

            }

            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
        },

        editar_contatos (item) { 
            this.$util.load(this, { 
                service: 'apoiados', 
                func: 'show',
                parms: { 
                    id: item.id_apoiado,
                    contatos: true, 
                },
                loadTo: res => { 

                    this.edicao = res;

                    this.edicao.model = { 
                        type: 'apoiado',
                        id: item.id_apoiado, 
                    };

                    this.$refs.regcontatos.editar(this.edicao);        

                }
            });
        },

        filtrar(texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        addTagOrigem (newTag) {
            this.options_classes_origem.push(newTag);

            if ( !this.edicao_origem.js_classes )
                this.edicao_origem.js_classes = [];

            this.edicao_origem.js_classes.push(newTag);
        },

        redefinir_senha (usuario) { 
            if ( this.$store.state.loading ) { 
                return;
            }

            /*
            if ( !confirm('Confirma redefinir a senha do apoiado?') ) { 
                return;
            }
            */

            this.$util.atualizar(this, { 
                service: 'apoiados',
                func: 'resetar_senha_login_portal', 
                dados: { 
                    id_apoiado: this.item.id_apoiado, 
                    id_usuario: usuario.id_usuario, 
                    senha: usuario.aleatoria ? null : usuario.st_senha,
                    classe: usuario.classe, 
                },
                callback: res => { 
                    $('.modal').modal('hide');
                    alert('Nova Senha: ' + res.senha);
                }
            });
        },

        criar_login_portal () { 
            if ( this.$store.state.loading ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'apoiados',
                func: 'criar_login_portal', 
                dados: { 
                    id_apoiado: this.item.id_apoiado,
                    novo_login: this.novo_login,  
                    nova_origem: this.nova_origem, 
                },
                modal: 'edicaoModal',
                callback: res => { 
                    this.novo_login = "";
                    this.nova_origem = "";
                    alert('Senha: ' + res.senha);
                    this.load();
                }
            });
        },

        buscarItems () { 
            if ( this.is_origens )
                return;

            if ( this.pesquisar_debounce )
                clearTimeout(this.pesquisar_debounce);

            this.pesquisar_debounce = setTimeout(() => {
                this.load();
                clearTimeout(this.timeout);
            }, 1000);
        },
        
        incluir () { 
            this.validate = false;

            let item;

            if ( this.is_origens ) { 
                
                item = { 
                    id_apoiado_origem: null, 
                    id_apoiado: this.item.id_apoiado,
                    fl_ativo: true, 
                    st_nome: "", 
                    st_sigla: "",
                    st_id_externo: "", 
                    st_observacao: "", 
                    id_plano: "",
                    id_recepcao: "", 
                    recepcao: "", 
                    js_classes: [], 
                };

            } else { 

                item = {
                    id_apoiado: null, 
                    st_nome: "",
                    st_sigla: "", 
                    st_id_externo: "", 
                    fl_ativo: true, 
                    js_classes: [], 
                    js_outros_campos: null, 
                    filtros: [], 
                    deparas: [], 
                };

            }

            this.editar (item);
        },

        load (page = 1) { 

            if ( this.is_origens ) { 

                this.$util.load(this, { 
                    service: 'apoiado_origens', 
                    func: 'index',
                    parms: { 
                        where: { 
                            id_apoiado: this.item.id_apoiado, 
                        }
                    },
                    loadTo: res => { 
                        this.lista_origens = res;
                    }
                });

            } else { 

                this.$util.load(this, { 
                    service:'apoiados',
                    func: 'index',
                    parms: { 
                        size: 30, 
                        page: page, 
                        cadastro: true, 
                        search: this.search, 
                        view_mode: this.viewMode, 
                        recepcao: this.recepcao, 
                    },
                    loadTo: res => { 
                        this.dados = res;
                        if ( page > 1 && res.last_page < page ) { 
                            this.load(1);
                        }
                    }
                });

            }
        },

        editar (item) { 
            this.validate = false;

            if ( this.is_origens ) { 

                this.edicao_origem = _.cloneDeep (item);
                $('#apoiadoOrigemModal').modal('show');

            } else { 

                if ( item.id_apoiado ) { 

                    this.$util.load(this, { 
                        service: 'apoiados', 
                        func: 'show',
                        parms: { 
                            id: item.id_apoiado,
                            cadastro: true, 
                        },
                        loadTo: res => { 
                            this.item = res;
                            $('#edicaoModal').modal('show');
                        }
                    });

                } else { 

                    this.item = _.cloneDeep (item);

                    $('#edicaoModal').modal('show');

                }

            }
            
        },

        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'apoiados',
                dados: { 
                    ...this.item,
                    cadastro: true, 
                    // recepcao: this.recepcao, 
                },
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        atualizar_origem () { 

            this.$util.atualizar(this, { 
                service: 'apoiado_origens',
                dados: { 
                    ...this.edicao_origem,
                    cadastro: true, 
                },
                reload: true, 
                modal: 'apoiadoOrigemModal',
            });

        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: this.is_origens ? 'apoiado_origens' : 'apoiados',
                dados: item,
            });

        },
    },

    mounted () { 

        // Carregar Enquetes... 
        this.$util.loadItem(this, { 
            service: 'enquetes',
            func: 'index', 
            parms: { 
                where: { 
                    model_type: 'App\\azure\\apoiado', 
                    fl_ativo: 1, 
                }
            }
        })
        .then(res => { 
            this.lista_enquetes = res;
        });

        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Apoiados", method: this.fechar },
            ];
        
        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, { 
            service: 'apoiados',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        this.$util.loadItem(this, { 
            service: 'apoiados',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        //

        this.$util.loadItem(this, { 
            service: 'contato_status',
            func: 'index',
            parms: { 
                model: 'apoiado'
            },
        })
        .then(res => {

            this.lista_status = res;
        
            if ( this.lista_status ) { 
                this.lista_status.push({ 
                    id_contato_status: 'R',
                    st_contato_status: 'Registrado',
                    search: 'Registrado',
                });
            }

        });


    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>